import React from "react";

const CountryFlag = ({
  countryCode,
  altText = "Country Flag",
  width = 15,
  height = 15,
}) => {
  if (!countryCode) return null;

  return (
    <img
      src={`https://flagcdn.com/w1280/${countryCode.toLowerCase()}.png`}
      width={width}
      height={height}
      alt={altText}
      loading="lazy"
    />
  );
};

export default CountryFlag;
